import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/icon.module.css";

export default {
  "icon": "icon-module__icon_0La-rG__010"
};
      